/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function requestAuthToken({ agencyId, agencySecret }) {
  return axios.post(`/auth/${agencyId}/token`, { agency_secret: agencySecret });
}

export function getRuntimeSDK({ agencyId, params, signal }) {
  return axios.get(`/auth/${agencyId}/sdk`, { params, signal });
}

export function getPermissions({ signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get('/auth/scopes', { headers, signal })
}
